import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-checkbox-with-list',
    templateUrl: './checkbox-with-list.component.html',
    styleUrls: ['./checkbox-with-list.component.scss'],
    standalone: false
})
export class CheckboxWithListComponent implements OnInit {
  @Input() options: { label: string, value: any, isChecked: boolean }[] = [];
  @Input() parentFormGroup: FormGroup = new FormGroup({});
  @Input() controlName = '';
  @Input() label = '';
  @Input() displaySelectAll = true;
  @Input() disabled = false;
  @Output() selectionChange = new EventEmitter<any[]>();
  @Output() checkForErrors = new EventEmitter();

  filteredOptions: { label: string, value: any, isChecked: boolean }[] = [];
  isAllChecked = false;
  fieldSubscription: Subscription | undefined;
  isRequired = false;


  ngOnInit(): void {
    const control = this.parentFormGroup.controls[this.controlName];
    this.fieldSubscription = control?.valueChanges.subscribe(() => {

      // If field is marked as touched, mark it as untouched
      if (this.parentFormGroup.controls[this.controlName]?.touched) {
        this.parentFormGroup.controls[this.controlName].markAsUntouched();
      }

      // Get errors on the form field
      const errors = this.parentFormGroup?.controls?.[this.controlName]?.errors;

      // If errors exist, handle it
      if (errors) {
        // Clear errors on the form field
        this.parentFormGroup.controls[this.controlName].setErrors(null);

        // Clear out the error messages on the screen (parent component)
        this.checkForErrors.emit(this.controlName);

        // Add errors again to the form field for showing messages in the future
        this.parentFormGroup.controls[this.controlName].setErrors(errors);
      } else {
        // Clear out the error messages on the screen (parent component)
        this.checkForErrors.emit(this.controlName);
      }
    });

    // Check if field is required
    if (control?.validator) {
      const validator = control?.validator({} as AbstractControl);
      this.isRequired = !!(validator && validator['required']);
    }

    this.filteredOptions = [...this.options];

    // Initial check for "All" checkbox state
    this.updateAllCheckedState();
  }

  updateAllCheckedState(): void {
    this.isAllChecked = this.options.every(option => option.isChecked);
  }

  onAllCheckboxChange(event: any): void {
    const isChecked = !!event.checked;
    this.options.forEach(option => option.isChecked = isChecked);
    this.updateAllCheckedState();
    this.emitSelectionChange();
  }

  onCheckboxChange(event: any, index: number): void {
    const checked = !!event.checked;
    this.filteredOptions[index].isChecked = checked;
    if (this.options[index] !== undefined) {
      this.options[index].isChecked = checked;
    }
    this.updateAllCheckedState();
    this.emitSelectionChange();
  }

  isPartiallyChecked(): boolean {
    const checkedCount = this.options.filter(option => option.isChecked).length;
    return checkedCount > 0 && checkedCount < this.options.length;
  }

  emitSelectionChange(): void {
    const selectedValues = this.options.filter(option => option.isChecked).map(option => option.value);
    this.selectionChange.emit(selectedValues);
  }
}
